var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('Landing',{attrs:{"landingData":_vm.landingData}}),_c('Works'),_c('ForJobSeeker'),_c('Testimonial'),_c('PartnerCompanies'),_c('Contact',{attrs:{"bgColor":"#3A3A4C"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }